const ThreeDotsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.19141 11.25C4.84766 11.25 4.55342 11.1276 4.3087 10.8827C4.06384 10.638 3.94141 10.3438 3.94141 10C3.94141 9.65625 4.06384 9.36201 4.3087 9.11729C4.55342 8.87243 4.84766 8.75 5.19141 8.75C5.53516 8.75 5.82946 8.87243 6.07432 9.11729C6.31905 9.36201 6.44141 9.65625 6.44141 10C6.44141 10.3438 6.31905 10.638 6.07432 10.8827C5.82946 11.1276 5.53516 11.25 5.19141 11.25ZM9.99911 11.25C9.65536 11.25 9.36113 11.1276 9.11641 10.8827C8.87155 10.638 8.74911 10.3438 8.74911 10C8.74911 9.65625 8.87155 9.36201 9.11641 9.11729C9.36113 8.87243 9.65536 8.75 9.99911 8.75C10.3429 8.75 10.6371 8.87243 10.8818 9.11729C11.1267 9.36201 11.2491 9.65625 11.2491 10C11.2491 10.3438 11.1267 10.638 10.8818 10.8827C10.6371 11.1276 10.3429 11.25 9.99911 11.25ZM14.8068 11.25C14.4631 11.25 14.1688 11.1276 13.9239 10.8827C13.6792 10.638 13.5568 10.3438 13.5568 10C13.5568 9.65625 13.6792 9.36201 13.9239 9.11729C14.1688 8.87243 14.4631 8.75 14.8068 8.75C15.1506 8.75 15.4448 8.87243 15.6895 9.11729C15.9344 9.36201 16.0568 9.65625 16.0568 10C16.0568 10.3438 15.9344 10.638 15.6895 10.8827C15.4448 11.1276 15.1506 11.25 14.8068 11.25Z"
        fill="#525252"
      />
    </svg>
  );
};

export default ThreeDotsIcon;
